"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author Vahagn Lazyan.
 * @since 1.1.0
 */
var operators_1 = require("rxjs/operators");
var http_1 = require("@angular/common/http");
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var ReplaySubject_1 = require("rxjs/ReplaySubject");
var form_resolver_service_1 = require("./form-resolver.service");
/**
 * Extension of {@link FormResolverService} based on json.
 * Provides urls, mapped in routes.json file.
 *
 * @class
 * @extends FormResolverService
 */
var JsonBasedFormResolverService = /** @class */ (function (_super) {
    __extends(JsonBasedFormResolverService, _super);
    function JsonBasedFormResolverService(http, router) {
        var _this = _super.call(this, router) || this;
        _this.http = http;
        _this.appRoutingConfigs = 'app/dummy/routes.json';
        _this.appRoutesReplaySubject = new ReplaySubject_1.ReplaySubject(1);
        _this.http.get(_this.appRoutingConfigs)
            .toPromise()
            .then(function (model) {
            _this.appRoutesReplaySubject.next(model);
            _this.appRoutesReplaySubject.complete();
        });
        return _this;
    }
    /**
     * Navigates to create new dynamic data-entry form.
     *
     * Returns a promise that:
     * - resolves to 'true' when navigation succeeds,
     * - resolves to 'false' when navigation fails,
     * - is rejected when an error happens.
     *
     * @param {string} categorySystemName
     * @param {string} formName
     * @returns {Promise<boolean>}
     */
    JsonBasedFormResolverService.prototype.navigateToCreateNewDeForm = function (categorySystemName, formName) {
        return this.navigateToDynamicDeForm(categorySystemName, formName);
    };
    /**
     * Navigates to editable dynamic data-entry form.
     *
     * Returns a promise that:
     * - resolves to 'true' when navigation succeeds,
     * - resolves to 'false' when navigation fails,
     * - is rejected when an error happens.
     *
     * @param {string} categorySystemName
     * @param {string} formName
     * @param {number} instanceId
     * @param {number} formId
     * @param {object} queryParams
     * @param {string} tabId
     * @returns {Promise<boolean>}
     */
    JsonBasedFormResolverService.prototype.navigateToEditDeForm = function (categorySystemName, formName, instanceId, formId, queryParams, tabId) {
        return this.navigateToDynamicDeForm(categorySystemName, formName, undefined, instanceId, undefined, tabId);
    };
    /**
     * Navigates to dynamic view data-entry form.
     *
     * Returns a promise that:
     * - resolves to 'true' when navigation succeeds,
     * - resolves to 'false' when navigation fails,
     * - is rejected when an error happens.
     *
     * @param {string} categorySystemName
     * @param {string} formName
     * @param {number} instanceId
     * @param {number} formId
     * @param {object} queryParams
     * @param {string} tabId
     * @returns {Promise<boolean>}
     */
    JsonBasedFormResolverService.prototype.navigateToViewDeForm = function (categorySystemName, formName, instanceId, formId, queryParams, tabId) {
        return this.navigateToDynamicDeForm(categorySystemName, formName, undefined, instanceId, undefined, tabId);
    };
    /**
     * Creates navigation url for create new dynamic de forms.
     * @param {string} categorySystemName
     * @param {string} formName
     * @returns {string}
     */
    JsonBasedFormResolverService.prototype.getUrlForCreateNewDeForm = function (categorySystemName, formName) {
        return this.getUrlForDynamicForm(categorySystemName, formName);
    };
    /**
     * Creates navigation url for edit dynamic de forms.
     * @param {string} categorySystemName
     * @param {string} formName
     * @param {number} instanceId
     * @returns {string}
     */
    JsonBasedFormResolverService.prototype.getUrlForEditDeForm = function (categorySystemName, formName, instanceId) {
        return this.getUrlForDynamicForm(categorySystemName, formName, instanceId);
    };
    /**
     * Creates navigation url for view dynamic de forms.
     * @param {string} categorySystemName
     * @param {string} formName
     * @param {number} instanceId
     * @returns {string}
     */
    JsonBasedFormResolverService.prototype.getUrlForViewDeForm = function (categorySystemName, formName, instanceId) {
        return this.getUrlForDynamicForm(categorySystemName, formName, instanceId);
    };
    JsonBasedFormResolverService.prototype.getUrlForCreateNewDeFormSync = function (categorySystemName, formName, formId, queryParams) {
        throw new Error('Not implemented yet');
    };
    JsonBasedFormResolverService.prototype.getUrlForEditDeFormSync = function (categorySystemName, formName, instanceId, formId, queryParams) {
        throw new Error('Not implemented yet');
    };
    JsonBasedFormResolverService.prototype.getUrlForViewDeFormSync = function (categorySystemName, formName, instanceId, formId, queryParams) {
        throw new Error('Not implemented yet');
    };
    JsonBasedFormResolverService.prototype.navigateToDynamicDeForm = function (categorySystemName, formName, formId, instanceId, queryParams, tabId) {
        var _this = this;
        return this.appRoutesReplaySubject.pipe(operators_1.mergeMap(function (routes) {
            var url = _this.findUrl(routes, categorySystemName, formName);
            if (instanceId !== undefined) {
                url = url.replace('{instanceId}', instanceId.toString());
            }
            if (tabId !== undefined) {
                url += '#' + tabId;
            }
            return _this.router.navigateByUrl(url);
        })).toPromise();
    };
    JsonBasedFormResolverService.prototype.getUrlForDynamicForm = function (categorySystemName, formName, instanceId) {
        var _this = this;
        return this.appRoutesReplaySubject.pipe(operators_1.map(function (routes) {
            var url = _this.findUrl(routes, categorySystemName, formName);
            return instanceId === undefined ? url : url.replace('{instanceId}', instanceId.toString());
        })).toPromise();
    };
    JsonBasedFormResolverService.prototype.findUrl = function (routes, categorySystemName, formName) {
        var category = routes.categories.find(function (categoryModel) {
            return categoryModel.category === categorySystemName;
        });
        if (category === undefined) {
            throw Error("There is no " + categorySystemName + " category in routes.json");
        }
        else {
            var form = category.forms.find(function (formModel) {
                return formModel.formId === formName;
            });
            if (form === undefined) {
                throw Error("There is no " + formName + " formName in " + categorySystemName + " category in routes.json");
            }
            else {
                return form.formUrl;
            }
        }
    };
    JsonBasedFormResolverService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient,
            router_1.Router])
    ], JsonBasedFormResolverService);
    return JsonBasedFormResolverService;
}(form_resolver_service_1.FormResolverService));
exports.JsonBasedFormResolverService = JsonBasedFormResolverService;
//# sourceMappingURL=json-based-form-resolver.service.js.map